import { useState } from "react";
import { ensureAudio, isMuted, setMuted } from "../audio/AudioEngine";
import { useSettingsStore } from "../state/useSettingsStore";

export function SoundToggle() {
  const [muted, setMutedState] = useState(() => isMuted());
  const toggle = () => {
    ensureAudio();
    const next = !muted;
    setMuted(next);
    setMutedState(next);
  };
  return (
    <button
      className="chip-toggle"
      aria-pressed={!muted}
      aria-label={muted ? "Turn sound on" : "Turn sound off"}
      title={muted ? "Sound: off" : "Sound: on"}
      onClick={toggle}
    >
      {muted ? "🔇" : "🔊"}
    </button>
  );
}

export function MotionToggle() {
  const reduced = useSettingsStore((s) => s.reducedMotion);
  const setReduced = useSettingsStore((s) => s.setReducedMotion);
  return (
    <button
      className="chip-toggle"
      aria-pressed={reduced}
      aria-label={reduced ? "Turn animations back on" : "Reduce motion"}
      title={reduced ? "Motion: reduced" : "Motion: full"}
      onClick={() => setReduced(!reduced)}
    >
      {reduced ? "🧘" : "✨"}
    </button>
  );
}
